import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { AngleDown } from '@zooplus/icons';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import formControlWrapStyle from '../FormControlWrap/FormControlWrap.module.scss.js';
import selectStyle from '../Select/Select.module.scss.js';
import textInputStyle from '../style/text-input.module.scss.js';
import style from './FormFieldProxy.module.scss.js';

const { componentTestLabel, elementTestLabel } = getTestLabels('FormFieldProxySelect');
const ProxySelect = ({ children, className, ...otherProps }) => {
    return (jsxs("div", { "data-zta": componentTestLabel, className: classNames(formControlWrapStyle['z-form-control-wrap'], className), children: [jsx("div", { "data-zta": elementTestLabel('Container'), className: classNames(textInputStyle['z-text-input'], selectStyle['z-select'], style['z-form-field-proxy__container']), ...otherProps, children: children }), jsx(AngleDown, { "aria-hidden": true, className: selectStyle['z-select__arrow'] })] }));
};

export { ProxySelect };
//# sourceMappingURL=ProxySelect.js.map
